/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dataprocessSteptype
 */
export interface DataprocessSteptype { 
    id?: number;
    /**
     * name of the dataprocessSteptype
     */
    name?: string;
    /**
     * target of the dataprocessSteptype
     */
    target?: string;
    /**
     * jsonString for the metadata of the dataprocessSteptype
     */
    metadata?: string;
}

